import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { LocalStorageService } from '../local-storage.service';
import { isJwtExpired } from './jwt.util';

@Injectable({
  providedIn: 'root'
})
export class LoggedInRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private storageService: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // During SSR/prerender there is no localStorage; let the route prerender normally.
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    // Checked directly on the stored token, not via AuthenticationService: the
    // guard must not depend on that service's constructor having run first.
    const token = this.storageService.getItem('token');
    if (token && !isJwtExpired(token)) {
      this.router.navigate(['/profile'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
